<template>
   <div class="programs-index"> 
        <v-tabs centered background-color="transparent">
                <v-tab @click="$inertia.visit('/backoffice/exercises')">Exercises</v-tab>
                <v-tab @click="$inertia.visit('/backoffice/workouts')">Workouts</v-tab>
                <v-tab @click="$inertia.visit('/backoffice/programs')">Programs</v-tab>
            </v-tabs>
       <div class="page-header">
            <div class="left">
                <h2 class="page-title">{{ $page.props.lang.title || "Programs" }}</h2>
            </div>
            <div class="right">
                <v-btn color="primary" dark>
                    <v-icon small>mdi-plus</v-icon>
                    <span v-if="$vuetify.breakpoint.mdAndUp" class="ml-2">{{ $page.props.lang.new_program || "New Program" }}</span>
                </v-btn>
            </div>
        </div>
   </div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
export default {
    metaInfo() {
        return {
            title:  this.$page.props.lang.title || "Programs"
        }
    },
    layout: AppLayout
}
</script>